import React, { useState, useEffect, useCallback } from 'react'
import './App.css'
import { Link, useHistory, useLocation } from 'react-router-dom'
import axios from 'axios'
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton'
import TopBarProgress from 'react-topbar-progress-indicator'
import { API_URL } from './config'
import { BiSolidLocationPlus } from 'react-icons/bi'
import { BsClock } from 'react-icons/bs'

const IndexedEvents = ({ limit = null }) => {
  const history = useHistory()
  const location = useLocation()

  // 1. State Management
  const [province] = useState(location.state?.province || '')
  const [currentEvent, setCurrentEvent] = useState([])
  const [userData, setUserData] = useState({
    email: '',
    phone: '',
    customername: '',
  })

  const [loading, setLoading] = useState({
    loadBarProgress: true,
    error: null,
  })

  const customerid = localStorage.getItem('customerid')
  const accounttype = localStorage.getItem('accounttype')

  // 2. Fetch Logic
  const fetchEvents = useCallback(
    (prov) => {
      const queryProv = prov ? `&province=${prov}` : ''
      const apiUrlCur = `${API_URL}/apps/kscanner/webservices.php?query=INDEXED-EVENTS${queryProv}`

      fetch(apiUrlCur)
        .then((res) => res.json())
        .then((result) => {
          let events = Array.isArray(result) ? result : []
          if (limit) events = events.slice(0, limit) // Apply limit if provided
          setCurrentEvent(events)
          setLoading((prev) => ({ ...prev, loadBarProgress: false }))
        })
        .catch((err) => setLoading((prev) => ({ ...prev, error: err })))
    },
    [limit]
  )

  useEffect(() => {
    if (customerid) {
      axios
        .get(
          `${API_URL}/apps/kscanner/webservices.php?query=CUSTOMERDETAILS&accountid=${customerid}`,
          {
            withCredentials: true,
          }
        )
        .then((response) => {
          setUserData({
            email: response.data.email,
            phone: response.data.phone,
            customername: response.data.customername,
          })
        })
        .catch((err) => console.error('User fetch error:', err))
    }
    fetchEvents(province)
  }, [province, fetchEvents, customerid])

  // 3. Date logic for visibility filter
  const date = new Date()
  const fulldate = `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(
    date.getDate()
  ).padStart(2, '0')}`

  if (loading.error) return <div className="text-danger p-3">Error loading events.</div>

  return (
    <div className="event-component-wrapper">
      {loading.loadBarProgress && (
        <>
          <TopBarProgress />
          <SkeletonTheme color="#BEC3C9" highlightColor="#e2e2e2">
            <div className="row">
              {[1, 2, 3, 4].map((i) => (
                <div key={i} className="col-lg-3 col-md-4 col-sm-6 col-12 mb-3">
                  <Skeleton height={200} />
                  <Skeleton count={2} />
                </div>
              ))}
            </div>
          </SkeletonTheme>
        </>
      )}

      <div className="row">
        {currentEvent.length === 0 && !loading.loadBarProgress ? (
          <div className="col-12 text-center p-5">No events found.</div>
        ) : (
          currentEvent.map((item, index) => {
            const posterUri = `${item.poster}`
            const isVisible = !(item.balance < 3.5 && item.event_day > fulldate)

            if (!isVisible) return null

            return (
              <div
                key={item.eventid || index}
                className="col-lg-3 col-md-4 col-sm-6 col-12 mb-3 d-flex"
              >
                <a
                  href={item.url}
                  target="_blank"
                  className="event-link w-100 text-decoration-none"
                >
                  <div className="event-card">
                    <div className="event-poster" style={{ backgroundImage: `url(${posterUri})` }}>
                      <span className="event-date-badge">{item.sdate}</span>
                      <span className="event-time-badge">
                        <BsClock /> {item.stime}
                      </span>
                    </div>
                    <div className="event-details">
                      <h5 className="event-title">
                        {/* {item.event_name.length > 23
                                                   ? item.event_name.substr(0, 23) + '...'
                                                   : item.event_name} */}
                        {item.eventname}
                      </h5>
                      <p className="event-location">
                        <BiSolidLocationPlus /> {item.location}
                      </p>
                      {/* <span className="event-category-badge">{item.eventcategory}</span> */}
                      <label
                        className="mt-3 event-description"
                        dangerouslySetInnerHTML={{
                          __html:
                            item.description.length > 100
                              ? item.description.substr(0, 100) + '...'
                              : item.description,
                        }}
                      ></label>
                    </div>
                  </div>
                </a>
              </div>
            )
          })
        )}
      </div>
    </div>
  )
}

export default IndexedEvents
